import React, { Fragment, useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { Reveal } from '../Reveal';
import { Button } from '../Button';
import { MechanismNode } from '../mechanism/MechanismNode';
import { MechanismConnector } from '../mechanism/MechanismConnector';
import { mechanismSteps } from '../../data/study';
import { useLayout } from '../../contexts/LayoutContext';
import { EASE } from '../../utils/motion';
type MechanismScreenProps = {
  onNext: () => void;
};
export function MechanismScreen({
  onNext
}: MechanismScreenProps) {
  const reduce = useReducedMotion();
  const {
    compact
  } = useLayout();
  const [intervened, setIntervened] = useState(false);
  useEffect(() => {
    const t = window.setTimeout(() => setIntervened(true), reduce ? 0 : 1800);
    return () => window.clearTimeout(t);
  }, [reduce]);
  return <div className={`flex min-h-full flex-col ${compact ? 'py-6' : 'justify-center py-10'}`} data-id="element-104" data-mp="ws7bbnbcs40m">
      <Reveal data-id="element-105" data-mp="5dtjs5aj1viw">
        <h2 className={`font-display font-light tracking-[-0.03em] text-ink ${compact ? 'text-[2.1rem] leading-[1.08]' : 'text-5xl leading-[1.05]'}`} data-id="element-106" data-mp="5dl9ml5sh4be">
          A different way to intervene
        </h2>
      </Reveal>

      <Reveal delay={0.12} data-id="element-107" data-mp="f5qxpjsx71lb">
        <div className={compact ? 'mt-10 flex flex-col' : 'mt-20 flex flex-row items-center'} data-id="element-108" data-mp="a49xzrm69l6b">
          {mechanismSteps.map((label, i) => <Fragment key={label} data-id="element-109" data-mp="3il50h5z253jv" data-mpi={i}>
              <MechanismNode label={label} dimmed={intervened && i > 0} compact={compact} data-id="element-110" data-mp="3dljs64xzziuh" />
              {i < mechanismSteps.length - 1 && <MechanismConnector dimmed={intervened} showInhibitor={intervened && i === 0} compact={compact} data-id="element-111" data-mp="3sjudakc3jxt9" />}
            </Fragment>)}
        </div>
      </Reveal>

      <div className={compact ? 'mt-10 min-h-[9.5rem]' : 'mt-16 min-h-[9rem]'} data-id="element-112" data-mp="17ripq4crnqgr">
        <AnimatePresence data-id="element-113" data-mp="12u0da3zjit40">
          {intervened && <motion.div initial={reduce ? false : {
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.28,
          delay: 0.15,
          ease: EASE
        }} data-id="element-114" data-mp="12t7cdjn9ixts">
              <p className={`font-semibold text-accent ${compact ? 'text-xl' : 'text-2xl'}`} data-id="element-115" data-mp="1exl80mzc35g7">
                Preferential PDE4B inhibition
              </p>
              <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-muted" data-id="element-116" data-mp="1osmxxl1fobju">
                JASCAYD interrupts a signalling pathway associated with fibrotic and inflammatory activity.
              </p>
              <p className="mt-6 text-sm text-ink" data-id="element-117" data-mp="w5sb4hh59037">JASCAYD® · nerandomilast</p>
            </motion.div>}
        </AnimatePresence>
      </div>

      <Reveal delay={0.2} className={compact ? 'mt-auto pt-6' : 'mt-6'} data-id="element-118" data-mp="15utv0iqt81mg">
        <Button fullWidth={compact} onClick={onNext} disabled={!intervened} data-id="element-119" data-mp="15wwt7q249129">
          Continue
        </Button>
      </Reveal>
    </div>;
}